/**
 * Afrikaans
 */
export const af_za = {
    locale: 'af-ZA',
    messages: {
        after: "Moet na ${date} wees",
        alpha: "Mag net letters gebruik",
        alphanumeric: "Mag net letters of syfers gebruik",
        array: "Moet 'n array wees",
        ascii: "Mag net ASCII karakters genruik",
        base64: "Moet Base64 data wees",
        before: "Moet voor ${date} wees",
        between: "Moet tussen ${min} en ${max} wees",
        between_inclusive: "Moet tussen of gelyk aan ${min} en ${max} wees",
        boolean: "Moet 'true' of 'false' wees",
        creditcard: "Moet 'n geldige kredietkaardnommer wees",
        date: "Met 'n geldige datum wees",
        dateformat: "Moet 'n geldige datum wees (${format})",
        defined: "Benodig 'n waarde",
        email: "Moet 'n geldig email adres wees",
        empty: "Moet leeg wees",
        equals: "Moet gelyk aan ${other} wees",
        gt: "Moet meer as ${min} wees",
        gte: "Moet meer as of gelyk aan ${min} wees",
        integer: "Moet 'n heelgetal wees",
        ip: "Moet 'n geldige IP adres wees",
        isblank: "Benodig 'n waarde",
        isnil: "Benodig 'n waarde",
        isnull: "Benodig 'n waarde",
        iso8601: "Moet 'n geldige ISO8601 datum wees",
        json: "Moet geldige JSON wees",
        length: "Moet 'n lengte van tenminste ${min} hê",
        length_between: "Moet 'n length tussen ${min} en ${max} hê",
        lt: "Moet minder as ${max} wees",
        lte: "Moet minder as of gelyk aan ${max} wees",
        match: "Moet ooreenstem met '${pattern}'",
        negative: "Moet 'n negatiewe getal wees",
        not: "Man nie ${value} wees nie",
        number: "Moet 'n nommer wees",
        numeric: "Moet 'n numeriese waarde hê",
        object: "Moet 'n 'object' wees",
        positive: "Moet 'n positiewe getal wees",
        required: "Benodig 'n waarde",
        same: "Moet dieselfde waarde as '${other}' wees",
        string: "Moet 'n 'string' wees",
        url: "Moet 'n geldige URL wees",
        uuid: "Moet 'n geldige UUID wees",
    },
}

/**
 * Arabic - Republic of Iraq
 */
export const ar_iq = {
    locale: 'ar-IQ',
    messages: {
        after: 'یجب ان یکون بعد ${date}',
        alpha: 'يمكن فقط استخدام الحروف',
        alphanumeric: 'يجب أن تكون أبجدية رقمية',
        array: 'يجب أن يكون مجموعة',
        ascii: 'يجب أن يكون ASCII',
        base64: 'يجب أن تكون صالحة Base64',
        before: 'يجب أن يكون قبل ${date}',
        between: 'يجب أن يتراوح بين ${min} و ${max}',
        between_inclusive: 'يجب أن يكون بين $ {min} و $ {max} ، او یشملهما',
        boolean: 'يجب أن تكون صحيحة أو خاطئة',
        creditcard: 'يجب أن يكون کرقم بطاقة ائتمان صحیحه',
        date: 'یجب ان یکون تاریخ صحیحه',
        dateformat: 'یجب ان یکون بشکل "${format}"',
        defined: 'مطلوب',
        email: 'يجب أن يكون عنوان بريد إلكتروني صحیحه',
        empty: 'يجب أن تكون فارغة',
        equals: 'یجب ان تکون مساویا لـ ${other}',
        gt: 'يجب أن يكون أكبر من ${min}',
        gte: 'يجب أن يكون أكبر من أو يساوي ${min}',
        integer: 'يجب أن يكون عددا صحيحا',
        ip: 'يجب أن يكون عنوان IP صالحًا',
        isblank: 'قد لا تكون فارغة',
        isnil: 'مطلوب',
        isnull: 'مطلوب',
        iso8601: 'يجب أن يكون تاريخ ISO8601 صالحًا',
        json: 'يجب أن يكون JSON صالح',
        length: 'يجب أن يكون طوله ${min} على الأقل',
        length_between: 'يجب أن يكون الطول بين ${min} و ${max}',
        lt: 'يجب أن يكون أقل من ${max}',
        lte: 'يجب أن يكون أقل من أو يساوي ${max}',
        match: 'يجب أن يطابق "$ {pattern}"',
        negative: 'يجب أن يكون رقمًا سالبًا',
        not: 'لا يمكن أن يكون $ {value}',
        number: 'يجب أن يكون رقما',
        numeric: 'يجب أن تكون رقمية',
        object: 'يجب أن يكون كائن',
        positive: 'يجب أن يكون رقما موجبا',
        required: 'مطلوب',
        same: 'يجب أن يكون له نفس القيمة مثل "$ {other}"',
        string: 'يجب أن يكون سلسلة',
        url: 'يجب أن يكون عنوان URL صالحًا',
        uuid: 'يجب أن يكون UUID صالح',
    },
}

/**
 * English - United States (Default)
 */
export const en_us = {
    locale: 'en-US',
    messages: {
        after: 'Must be after ${date}',
        alpha: 'Can only use letters',
        alphanumeric: 'Must be alphanumeric',
        array: 'Must be an array',
        ascii: 'Must be ASCII',
        base64: 'Must be valid Base64',
        before: 'Must be before ${date}',
        between: 'Must be between ${min} and ${max}',
        between_inclusive: 'Must be between ${min} and ${max}, inclusive',
        boolean: 'Must be true or false',
        creditcard: 'Must be a valid credit card number',
        date: 'Must be a valid date',
        dateformat: 'Must use "${format}" format',
        defined: 'Required',
        email: 'Must be a valid email address',
        empty: 'Must be empty',
        equals: 'Must be equal to ${other}',
        gt: 'Must be greater than ${min}',
        gte: 'Must be greater than or equal to ${min}',
        integer: 'Must be an integer',
        ip: 'Must be a valid IP address',
        isblank: 'May not be blank',
        isnil: 'Required',
        isnull: 'Required',
        iso8601: 'Must be a valid ISO8601 date',
        json: 'Must be a valid JSON',
        length: 'Must have a length of at least ${min}',
        length_between: 'Must have a length between ${min} and ${max}',
        lt: 'Must be less than ${max}',
        lte: 'Must be less than or equal to ${max}',
        match: 'Must match "${pattern}"',
        negative: 'Must be a negative number',
        not: 'Can not be ${value}',
        number: 'Must be a number',
        numeric: 'Must be numeric',
        object: 'Must be an object',
        positive: 'Must be a positive number',
        required: 'Required',
        same: 'Must have the same value as "${other}"',
        string: 'Must be a string',
        url: 'Must be a valid URL',
        uuid: 'Must be a valid UUID',
    },
}

/**
 * Persian - Islamic Republic of Iran
 */
export const fa_ir = {
    locale: 'fa-IR',
    messages: {
        after: 'باید بعد از ${date} باشد.',
        alpha: 'فقط می تواند ترکیبی از حروف باشد',
        alphanumeric: 'باید ترکیبی از اعداد و حروف باشد',
        array: 'باید یک آرایه باشد',
        ascii: 'باید کد اسکی (ASCII) باشد.',
        base64: 'باید یک مقدار صحیح از  Base64 باشد',
        before: 'باید قبل از ${date} باشد.',
        between: 'باید بین ${min} و ${max} باشد',
        between_inclusive: 'باید بزرگتر مساوی از${min} و کوچکتر مساوی از ${max} باشد',
        boolean: 'باید یک مقدار صحیح یا غلط باشد',
        creditcard: 'باید یک شماره کارت اعتباری معتبر باشد',
        date: 'باید یک تاریخ صحیح باشد',
        dateformat: 'باید به فرمت "${format}" باشد',
        defined: 'اجباری است',
        email: 'باید یک آدرس ایمیل معتبر باشد',
        empty: 'باید خالی (تهی) باشد',
        equals: 'باید برابر با ${other} باشد',
        gt: 'باید بزرگتر از ${min} باشد',
        gte: 'باید بزرگتر مساوی ${min} باشد',
        integer: 'باید یک عدد صحیح باشد',
        ip: 'باید یک آدرس IP معتبر باشد',
        isblank: 'نباید خالی باشد',
        isnil: 'اجباری است',
        isnull: 'اجباری است',
        iso8601: 'باید یک تاریخ معتبر ISO8601 باشد',
        json: 'باید یک JSON معتبرباشد',
        length: 'باید طولی به اندازه حداقل ${min} داشته باشد',
        length_between: 'باید طولی بین ${min} تا ${max} داشته باشد',
        lt: 'باید کوچکتر از ${max} باشد',
        lte: 'باید کوچکتر مساوی از ${max} باشد',
        match: 'باید شامل الگوی "${pattern}" باشد',
        negative: 'باید یک عدد منفی باشد',
        not: 'نباید برابر با ${value} باشد',
        number: 'باید یک عدد باشد',
        numeric: 'باید عددی باشد',
        object: 'باید یک شیء باشد',
        positive: 'باید یک عدد مثبت باشد',
        required: 'اجباری است',
        same: 'باید مقداری یکسان با "${other}" داشته باشد',
        string: 'باید رشته باشد',
        url: 'باید یک آدرس URL معتبر باشد',
        uuid: 'باید یک UUID معتبر باشد',
    },
}
/**
 * Portuguese - Brazil
 */
export const pt_br = {
    locale: 'pt-BR',
    messages: {
        after: 'Deve ser uma data posterior a ${date}',
        alpha: 'Deve conter somente letras',
        alphanumeric: 'Deve conter somente letras e números',
        array: 'Deve ser um array',
        ascii: 'Deve ser ASCII',
        base64: 'Deve ser um Base64 válido',
        before: 'Deve ser uma data anterior a ${date}',
        between: 'Deve estar entre ${min} e ${max}',
        between_inclusive: 'Deve estar entre ${min} e ${max}, inclusive',
        boolean: 'Deve ser verdadeiro ou falso',
        creditcard: 'Deve ser um número de cartão de crédito válido',
        date: 'Deve ser uma data válida',
        dateformat: 'Deve usar o formato "${format}"',
        defined: 'Campo obrigatório',
        email: 'Deve ser um endereço de email válido',
        empty: 'Deve ser vazio',
        equals: 'Deve ser igual a ${other}',
        gt: 'Deve ser maior que ${min}',
        gte: 'Deve ser maior ou igual a ${min}',
        integer: 'Deve ser um inteiro',
        ip: 'Deve ser um endereço de IP válido',
        isblank: 'Deve estar em branco',
        isnil: 'Campo obrigatório',
        isnull: 'Campo obrigatório',
        iso8601: 'Deve ser uma data ISO8601 válida',
        json: 'Deve ser um JSON válido',
        length: 'Deve ter o tamanho de pelo menos ${min}',
        length_between: 'Deve ter o tamanho entre ${min} e ${max}',
        lt: 'Deve ser menor que ${max}',
        lte: 'Deve ser menor ou igual a ${max}',
        match: 'Deve ter o formato "${pattern}"',
        negative: 'Deve ser um número negativo',
        not: 'Não pode ser ${value}',
        number: 'Deve ser um número',
        numeric: 'Deve ser numérico',
        object: 'Deve ser um object',
        positive: 'Deve ser um número positivo',
        required: 'Campo obrigatório',
        same: 'Deve ser igual a "${other}"',
        string: 'Deve ser uma string',
        url: 'Deve ser uma URL válida',
        uuid: 'Deve ser um UUID válido',

        // Custom
        cpf                : 'Insira um CPF válido',
        cnpj               : 'Insira um CNPJ válido',
        birthday           : 'Insira uma data de nascimento válida',
        password           : 'Insira uma senha válida, com pelo menos ${min} characteres e no máximo ${max}',
        required_password  : 'Insira sua senha atual para autorizar a atualização',
        phone              : 'Insira um número de celular válido',
        customInteger      : 'Insira um número inteiro',
        isNumberNonNegative: 'O número deve ser maior ou igual a 0',
        // [FID-653] Comentado temporariamente enquanto não habilitamos o telefone
        // required_contact   : 'Pelo menos uma forma de contato é necessária. Celular ou email.',
        positiveNumber : 'Deve ser um número real positivo entre ${min} e ${max} dígitos e valor máximo de ${maxValue}',
        positiveInteger: 'Deve ser um número inteiro positivo entre ${min} e ${max} dígitos e valor máximo de ${maxValue}',
        after_or_equal : 'Deve ser uma data posterior ou igual a ${date}',
        before_or_equal: 'Deve ser uma data anterior ou igual a ${date}',
    },
}

/**
 * Dutch - The Netherlands
 */
export const nl_nl = {
    locale: 'nl-NL',
    messages: {
        after: 'Moet na ${date} zijn',
        alpha: 'Kan alleen letters gebruiken',
        alphanumeric: 'Moet cijfers en/of letters zijn',
        array: 'Moet een lijst zijn',
        ascii: 'Moet ASCII zijn',
        base64: 'Moet geldige Base64 zijn',
        before: 'Moet voor ${date} zijn',
        between: 'Moet tussen ${min} en ${max} zijn',
        between_inclusive: 'Moet tussen of gelijk aan ${min} en ${max} zijn',
        boolean: 'Moet waar of onwaar zijn',
        creditcard: 'Moet een geldig credit card nummer zijn',
        date: 'Moet een geldige datum zijn',
        dateformat: 'Moet "${format}" indeling zijn',
        defined: 'Vereist',
        email: 'Moet een geldig emailadres zijn',
        empty: 'Moet leeg zijn',
        equals: 'Moet gelijk zijn aan ${other}',
        gt: 'Moet groter zijn dan ${min}',
        gte: 'Moet groter of gelijk zijn aan ${min}',
        integer: 'Moet een geheel getal zijn',
        ip: 'Moet een geldig IP address zijn',
        isblank: 'Mag niet leeg zijn',
        isnil: 'Vereist',
        isnull: 'Vereist',
        iso8601: 'Moet een geldige ISO8601 datum zijn',
        json: 'Moet een geldige JSON zijn',
        length: 'Moet ten minste ${min} karakters lang zijn',
        length_between: 'Moet tussen ${min} en ${max} karakters lang zijn',
        lt: 'Moet minder dan ${max}',
        lte: 'Moet minder of gelijk aan ${max} zijn',
        match: 'Moet overeenkomen met dit patroon "${pattern}"',
        negative: 'Moet een negatief getal zijn zijn',
        not: 'Mag niet ${value} zijn',
        number: 'Moet een getal zijn',
        numeric: 'Moet een getal zijn',
        object: 'Moet een object zijn',
        positive: 'Moet een positief nummer zijn',
        required: 'Vereist',
        same: 'Moet dezelfde waarde hebben als "${other}"',
        string: 'Moet een string zijn',
        url: 'Moet een geldige URL zijn',
        uuid: 'Moet een geldige UUID zijn',
    },
}

/**
 * Polish - Poland
 */
export const pl_pl = {
    locale: 'pl-PL',
    messages: {
        after: 'Musi być datą późniejszą od ${date}',
        alpha: 'Musi zawierać jedynie litery',
        alphanumeric: 'Musi zawierać jedynie litery i cyfry',
        array: 'Musi być tablicą',
        ascii: 'Musi zawierać tylko znaki ASCII',
        base64: 'Musi być kodowane w Base64',
        before: 'Musi być datą wcześniejszą od ${date}',
        between: 'Musi być pomiędzy ${min}, a ${max}',
        between_inclusive: 'Musi być pomiędzy ${min}, a ${max} włącznie',
        boolean: 'Musi mieć wartość prawda albo fałsz',
        creditcard: 'Musi być poprawnym numerem karty kredytowej',
        date: 'Musi być poprawną datą',
        dateformat: 'Data musi być w formacie "${format}"',
        defined: 'Pole wymagane',
        email: 'Musi być poprawnym adresem e-mail',
        empty: 'Musi być puste',
        equals: 'Musi wynosić ${other}',
        gt: 'Musi być większe od ${min}',
        gte: 'Musi być większe lub równe od ${min}',
        integer: 'Musi być liczbą całkowitą',
        ip: 'Musi być poprawnym adresem IP',
        isblank: 'Nie może być puste',
        isnil: 'Pole wymagane',
        isnull: 'Pole wymagane',
        iso8601: 'Musi być datą w formacie ISO8601',
        json: 'Musi być poprawnym ciągiem znaków JSON',
        length: 'Musi mieć długość co najmniej ${min} znaków',
        length_between: 'Musi mieć długość pomiędzy ${min}, a ${max} znaków',
        lt: 'Musi być mniejsze od ${max}',
        lte: 'Musi być mniejsze lub równe od ${max}',
        match: 'Musi być zgodne z "${pattern}"',
        negative: 'Musi być liczbą ujemną',
        not: 'Nie może być ${value}',
        number: 'Musi być numerem',
        numeric: 'Musi być liczbą',
        object: 'Musi być obiektem',
        positive: 'Musi być liczbą dodatnią',
        required: 'Pole wymagane',
        same: 'Musi mieć taką samą wartość jak pole "${other}"',
        string: 'Musi być ciągiem znaków',
        url: 'Musi być poprawnym adresem URL',
        uuid: 'Musi być poprawnym identyfikatorem UUID',
    },
}

/**
 * Russian - Russia
 */
export const ru_ru = {
    locale: 'ru-RU',
    messages: {
        after: 'Должен быть после ${date}',
        alpha: 'Разрешаются только буквы',
        alphanumeric: 'Разрешаются только цифро-буквенные символы',
        array: 'Должен быть массивом',
        ascii: 'Должен быть ASCII',
        base64: 'Должен быть Base64',
        before: 'Должен быть до ${date}',
        between: 'Должен быть от ${min} до ${max}',
        between_inclusive: 'Должен быть от ${min} до ${max}, включительно',
        boolean: 'Должен быть true либо false',
        creditcard: 'Должен быть действительным номером кредитной карты',
        date: 'Должен быть действительной датой',
        dateformat: 'Должен использовать формат "${format}"',
        defined: 'Обязателен',
        email: 'Должен быть действительным email адресом',
        empty: 'Должен быть пустым',
        equals: 'Должен быть равным ${other}',
        gt: 'Должен быть больше ${min}',
        gte: 'Должен быть больше или равен ${min}',
        integer: 'Должен быть целым числом',
        ip: 'Должен быть действительным IP адресом',
        isblank: 'Не может быть пустым',
        isnil: 'Обязателен',
        isnull: 'Обязателен',
        iso8601: 'Должен быть действительной ISO8601 датой',
        json: 'Должен быть действительным JSON объектом',
        length: 'Должен иметь минимальную длинну в ${min} символов',
        length_between: 'Должен иметь длинну между ${min} и ${max}',
        lt: 'Должен быть меньше ${max}',
        lte: 'Должен быть меньше или равен ${max}',
        match: 'Должен совпадать с "${pattern}"',
        negative: 'Должен быть отрицательным числом',
        not: 'Не может быть ${value}',
        number: 'Должен быть числом',
        numeric: 'Должен быть числовым',
        object: 'Должен быть объектом',
        positive: 'Должен быть положительным числом',
        required: 'Обязателен',
        same: 'Должен иметь такое же значение как и "${other}"',
        string: 'Должен быть строкой',
        url: 'Должен быть действительным URL',
        uuid: 'Должен быть действительным UUID',
    },
}

/**
 * Danish - Denmark
 */
export const da_dk = {
    locale: 'da-DK',
    messages: {
        after: 'Skal være efter ${date}',
        alpha: 'Må kun indeholde bogstaver',
        alphanumeric: 'Skal være alfanumerisk',
        array: 'Skal være en liste',
        ascii: 'Skal være ASCII',
        base64: 'Skal være gyldig Base64',
        before: 'Skal være før ${date}',
        between: 'Skal være mellem ${min} og ${max}',
        between_inclusive: 'Skal være mellem ${min} og ${max}, begge inklusive',
        boolean: 'Skal være enten sand eller falsk',
        creditcard: 'Skal være et gyldigt kreditkortnummer',
        date: 'Skal være en gyldig dato',
        dateformat: 'Skal følge formatet "${format}"',
        defined: 'Påkrævet',
        email: 'Skal være en gyldig e-mailadresse',
        empty: 'Må ikke have indhold',
        equals: 'Skal indeholde det samme som ${other}',
        gt: 'Skal være større end ${min}',
        gte: 'Skal være større end eller lig med ${min}',
        integer: 'Skal være et heltal',
        ip: 'Skal være en gyldig IP-adresse',
        isblank: 'Må ikke være tomt',
        isnil: 'Påkrævet',
        isnull: 'Påkrævet',
        iso8601: 'Skal være en gyldig ISO 8601 dato',
        json: 'Skal være gyldigt JSON',
        length: 'Skal have en længde på mindst ${min}',
        length_between: 'Skal have en længde på mellem ${min} og ${max}',
        lt: 'Skal være mindre end ${max}',
        lte: 'Skal være mindre end eller lig med ${max}',
        match: 'Skal passe mønstret "${pattern}"',
        negative: 'Skal være et negativt tal',
        not: 'Må ikke være ${value}',
        number: 'Skal være et tal',
        numeric: 'Skal være numerisk',
        object: 'Skal være et objekt',
        positive: 'Skal være et positivt tal',
        required: 'Påkrævet',
        same: 'Skal have sammen værdi som "${other}"',
        string: 'Skal være en tekststring',
        url: 'Skal være en gyldig URL',
        uuid: 'Skal være en gyldig UUID',
    },
}

/**
 * Indonesian - Indonesia
 */
export const id_id = {
    locale: 'id-ID',
    messages: {
        after: 'Harus sesudah ${date}',
        alpha: 'Hanya dapat menggunakan huruf',
        alphanumeric: 'Harus berupa alfanumerik',
        array: 'Harus berupa larik',
        ascii: 'Harus berupa ASCII',
        base64: 'Harus berupa Base64 valid',
        before: 'Harus sebelum ${date}',
        between: 'Harus di antara ${min} dan ${max}',
        between_inclusive: 'Harus di antara ${min} dan ${max}, inklusif',
        boolean: 'Harus berupa benar atau salah',
        creditcard: 'Harus berupa nomor kartu kredit valid',
        date: 'Harus berupa tanggal valid',
        dateformat: 'Harus menggunakan format "${format}"',
        defined: 'Wajib',
        email: 'Harus berupa alamat email valid',
        empty: 'Harus kosong',
        equals: 'Harus sama dengan ${other}',
        gt: 'Harus lebih dari ${min}',
        gte: 'Harus lebih dari atau sama dengan ${min}',
        integer: 'Harus berupa bilangan bulat',
        ip: 'Harus berupa alamat IP valid',
        isblank: 'Tidak boleh kosong',
        isnil: 'Wajib',
        isnull: 'Wajib',
        iso8601: 'Harus berupa tanggal ISO8601',
        json: 'Harus berupa JSON valid',
        length: 'Memiliki panjang paling tidak ${min}',
        length_between: 'Memiliki panjang di antara ${min} dan ${max}',
        lt: 'Harus kurang dari ${max}',
        lte: 'Harus kurang dari atau sama dengan ${max}',
        match: 'Harus sama "${pattern}"',
        negative: 'Harus berupa angka negatif',
        not: 'Tidak boleh ${value}',
        number: 'Harus berupa angka',
        numeric: 'Harus berupa numerik',
        object: 'Harus berupa objek',
        positive: 'Harus berupa angka positif',
        required: 'Wajib',
        same: 'Harus memiliki nilai yang sama dengan "${other}"',
        string: 'Harus berupa string',
        url: 'Harus berupa URL valid',
        uuid: 'Harus berupa UUID valid',
    },
}

/**
 * German - Germany
 */
export const de_de = {
    locale: 'de-DE',
    messages: {
        after: 'Muss später sein als ${date}',
        alpha: 'Kann nur Buchstaben enthalten',
        alphanumeric: 'Muss alphanumerisch sein',
        array: 'Muss ein Array sein',
        ascii: 'Muss in ASCII sein',
        base64: 'Muss valides Base64 sein',
        before: 'Muss früher sein als ${date}',
        between: 'Muss zwischen ${min} und ${max} sein',
        between_inclusive: 'Muss zwischen einschließlich ${min} und ${max} sein',
        boolean: 'Muss true oder false sein',
        creditcard: 'Muss eine valide Kreditkartennummer sein',
        date: 'Muss ein valides Datum sein',
        dateformat: 'Muss im Datumsformat "${format}" sein',
        defined: 'Erforderlich',
        email: 'Muss eine gültige e-Mail Adresse sein',
        empty: 'Muss leer sein',
        equals: 'Muss gleich sein mit ${other}',
        gt: 'Muss größer als ${min} sein',
        gte: 'Muss größer als oder gleich sein wie ${min}',
        integer: 'Muss eine Ganzzahl sein',
        ip: 'Muss eine gültige IP Adresse sein',
        isblank: 'Darf nicht leer sein',
        isnil: 'Erforderlich',
        isnull: 'Erforderlich',
        iso8601: 'Muss ein valides ISO8601 Datum sein',
        json: 'Muss valides JSON sein',
        length: 'Muss mindestens die Länge ${min} haben',
        length_between: 'Muss eine Länge zwischen ${min} und ${max} haben',
        lt: 'Muss weniger sein als ${max}',
        lte: 'Muss weniger sein als oder gleich ${max} sein',
        match: 'Muss dem pattern "${pattern}" entsprechen',
        negative: 'Muss eine negative Zahl sein',
        not: 'Darf nicht ${value} sein',
        number: 'Muss eine Zahl sein',
        numeric: 'Muss numerisch sein',
        object: 'Muss ein Objekt sein',
        positive: 'Muss eine positive Zahl sein',
        required: 'Erforderlich',
        same: 'Muss gleich "${other}" sein',
        string: 'Muss eine String sein',
        url: 'Muss eine valide URL sein',
        uuid: 'Muss eine valide UUID sein',
    },
}
